<script>
import Popup from './popup.vue';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    name: "refundPopup",
    data() {
        return {
            code: '',
            name: '',
        };
    },
    computed: {},
    components: {
        Popup
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 提交物流信息
        submitLogistics() { 
            if (!this.code.trim()) {
                this.$showToast({ text: '请输入物流单号' });
                return;
            }
            if (!this.name.trim()) {
                this.$showToast({ text: '请输入物流公司' });
                return;
            }
            this.$emit('submit-logistics', {
                code: this.code,
                name: this.name,
            });
        }
    },
};
</script>

<template>
    <Popup class="refund_popup" :show="show" title="退货并填写物流信息" :isShowClose="true" @close="$emit('close')">
        <div class="more_info">
            <p>收货人：奢颜艺术&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13701998955</p>
            <p>收货地址：中国江苏省苏州市昆山市花桥镇晨风路6号3号楼607室</p>
        </div>
        <div class="form">
            <div class="item">
                <p class="name">物流单号 *</p>
                <input type="text" placeholder="必填" v-model="code"/>
            </div>
            <div class="item">
                <p class="name">物流公司 *</p>
                <input type="text" placeholder="必填" v-model="name"/>
            </div>
        </div>
        <div class="bottom btn_group flex justify_end">
            <div class="btn big" @click="$emit('close')">取消</div>
            <div class="btn big" @click="submitLogistics">提交</div>
        </div>
    </Popup>
</template>

<style scoped lang="scss">
.refund_popup{
    .more_info{
        font-size: .14rem;
        line-height: 1.5;
        margin-bottom: .3rem;
        @media screen and (max-width: 750px) {
            font-size: .22rem;
            
        }
    }
    .bottom{
        margin-top: .2rem;
    }
}
</style>